import './styles.scoped.css'
import {useEffect, useState} from 'react'
import {Circle, MoreHoriz} from '@mui/icons-material'
import {useGlobalStates} from '../../contexts/GlobalStatesContext'
import {Typography, IconButton, Avatar, Menu, MenuItem, Popover, Badge} from '@mui/material'
import {Close, NotificationsActive} from '@mui/icons-material'
import {getInitials, getColorFromName, parseError} from '../../utils/helpers'
import {caregiverApi} from '../../services'
import {format} from 'date-fns'
import {NotificationPopUp} from '../../components'

export default () => {
    const [anchorEl, setAnchorEl] = useState(null)
    const [notifications, setNotifications] = useState([])
    const [notificationCount, setNotificationCount] = useState(0)
    // Only the first load shows a skeleton; background polling and post-mutation refreshes never do.
    const [skeleton, setSkeleton] = useState(true)
    const {setLoading, setMessageBox, branchId} = useGlobalStates()

    useEffect(() => {
        getNotifications()
        setInterval(getNotifications, 30 * 1000)
    }, [branchId])

    useEffect(() => {
        setNotificationCount(notifications?.filter(item => !item.read_at)?.length)
    }, [notifications])

    const getNotifications = (withLoading = false) => {
        if (branchId) {
            if (withLoading) {
                setLoading(true)
            }
            caregiverApi
                .getNotifications(branchId)
                .then(({data: {notifications: data}}) => {
                    if (withLoading) {
                        setLoading(false)
                    }
                    setNotifications(data)
                    setSkeleton(false)
                })
                .catch(error => {
                    if (withLoading) {
                        setLoading(false)
                    }
                    setSkeleton(false)
                    const {title, description} = parseError(error)
                    if (description) {
                        setMessageBox({status: 'error', title, description})
                    }
                })
        }
    }

    const menuOpen = e => {
        setAnchorEl(e.currentTarget)
    }

    const menuClose = () => {
        setAnchorEl(null)
    }

    return (
        <>
            <IconButton onClick={e => menuOpen(e)}>
                <Badge badgeContent={notificationCount} color="error">
                    <NotificationsActive
                        fontSize="medium"
                        sx={theme => ({
                            color: theme.palette.grey[800],
                        })}
                    />
                </Badge>
            </IconButton>
            <Popover
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={menuClose}
                anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                transformOrigin={{vertical: 'top', horizontal: 'right'}}
                PaperProps={{
                    sx: {
                        borderTopRightRadius: 0,
                        borderTopLeftRadius: 20,
                        borderBottomRightRadius: 20,
                        borderBottomLeftRadius: 20,
                        marginTop: 2,
                    },
                }}>
                <NotificationPopUp
                    menuCloseNotifications={menuClose}
                    items={notifications}
                    getNotifications={getNotifications}
                    skeleton={skeleton && !!branchId}
                />
            </Popover>
        </>
    )
}
